import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
const root = document.getElementById("root")!;
root.innerHTML = '';
createRoot(root).render(<App />);
import { registerSW } from 'virtual:pwa-register';
registerSW({ immediate: true });

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
            const swUrl = registration.active?.scriptURL || registration.waiting?.scriptURL || registration.installing?.scriptURL || '';
            if (swUrl.includes('registerSW.js')) {
                registration.unregister();
            }
        });
    });
}
